import {
  formatPrecisaoFloat,
  formatPrice,
  unformatPrice,
} from "../../../../utils";
import {
  CurrencyInput,
  Grid,
  TextFielDecimalNumbers,
  Typography,
} from "../../../../components/";
import {
  calculoDesconto,
  formatProdutosTotalizadores,
  totalOrcamento,
} from "../addOrcamentos";

const ResumoTotal = ({
  abaValue,
  orcamento,
  setOrcamento,
  listaOrcamentosProdutos,
  setListaOrcamentosProdutos,
  orcamentoEntity,
}) => {
  const handleInputChangeDespesa = (event) => {
    const name = "despesas";
    const valor = unformatPrice(event.target.value);
    const totalNota = totalOrcamento(listaOrcamentosProdutos, name);
    const listItensDespesas = formatProdutosTotalizadores(
      name,
      listaOrcamentosProdutos,
      valor,
      totalNota
    );
    setListaOrcamentosProdutos(listItensDespesas);
    orcamentoEntity.setChangeItens(listItensDespesas);
    setOrcamento({ ...orcamentoEntity });
  };

  const handleInputDesconto = (event) => {
    if (listaOrcamentosProdutos?.length) {
      const name = "desconto";
      const valor = unformatPrice(event.target.value);
      if (
        parseFloat(orcamento[event.target.name].toFixed(2)) !==
        formatPrecisaoFloat(parseFloat(valor))
      ) {
        const totalNota = totalOrcamento(listaOrcamentosProdutos, name);
        const orcamentoTemp = {
          ...orcamento,
          [event.target.name]: valor || 0,
        };
        if (event.target.name === "desconto") {
          orcamentoTemp.descontoPorcentagem = calculoDesconto(
            listaOrcamentosProdutos,
            orcamentoTemp,
            false
          );
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            listaOrcamentosProdutos,
            valor,
            totalNota
          );
          setListaOrcamentosProdutos(listItensDesconto);
          orcamentoEntity.setChangeItens(listItensDesconto);
          setOrcamento({ ...orcamentoEntity });
        } else {
          orcamentoTemp.desconto = calculoDesconto(
            listaOrcamentosProdutos,
            orcamentoTemp
          );
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            listaOrcamentosProdutos,
            orcamentoTemp?.desconto,
            totalNota
          );
          setListaOrcamentosProdutos(listItensDesconto);
          orcamentoEntity.setChangeItens(listItensDesconto);
          setOrcamento({ ...orcamentoEntity });
        }
      }
    }
  };

  const nextFocusInput = (event) => {
    if (event.keyCode === 13) {
      const { form } = event.target;
      const arrayInput = Array.from(form.elements).filter(
        (element) => element.tagName == "INPUT"
      );
      const index = arrayInput.indexOf(event.target);
      let element = arrayInput[index + 1];
      if (element?.disabled) {
        element = arrayInput[index + 2];
      }
      if (element) {
        element.focus();
      } else {
        arrayInput[index].blur();
      }
      event.preventDefault();
    }
  };

  return (
    <form>
      <Grid container spacing={2} className="mx-3">
        <Grid
          item
          xs={2}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Subtotal:</span>
          <span className="badge bg-primary bg-gradient bg-gradient text-wrap p-2">
            <Typography color="white" style={{ fontWeight: 700 }}>
              {formatPrice(orcamentoEntity?.totalItens || 0)}
            </Typography>
          </span>
        </Grid>
        <Grid
          item
          xs={5}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Desconto:</span>
          <TextFielDecimalNumbers
            id="descontoPorcentagem"
            name="descontoPorcentagem"
            disabled={
              orcamento.status === "CANCELADO" ||
              orcamento.status === "BAIXADO" ||
              abaValue !== 0 ||
              orcamento?.descontoItem
            }
            variant="outlined"
            margin="none"
            size="small"
            value={orcamento?.descontoPorcentagem ?? 0}
            onBlur={handleInputDesconto}
            onKeyDown={nextFocusInput}
          />
          <CurrencyInput
            id="desconto"
            name="desconto"
            disabled={
              orcamento.status === "CANCELADO" ||
              orcamento.status === "BAIXADO" ||
              abaValue !== 0 ||
              orcamento?.descontoItem
            }
            className="px-1"
            variant="outlined"
            margin="none"
            size="small"
            value={orcamento?.desconto}
            onBlur={handleInputDesconto}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid
          item
          xs={3}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Despesas:</span>
          <CurrencyInput
            id="despesas"
            name="despesas"
            disabled={
              orcamento.status === "CANCELADO" ||
              orcamento.status === "BAIXADO" ||
              abaValue !== 0 ||
              orcamento?.despesasItem
            }
            variant="outlined"
            margin="none"
            value={orcamento?.despesas ?? 0}
            size="small"
            onBlur={handleInputChangeDespesa}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid
          item
          xs={2}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Total:</span>
          <span className="badge bg-primary bg-gradient bg-gradient text-wrap p-2">
            <Typography color="white" style={{ fontWeight: 700 }}>
              {formatPrice(orcamentoEntity?.totalOrcamento || 0)}
            </Typography>
          </span>
        </Grid>
      </Grid>
    </form>
  );
};

export default ResumoTotal;
